import { ModelTypes } from '@/types'

export enum ROLE {
  Client = 'client',
}

export type BaseUserType = {
  id: number
  avatar: ModelTypes.AvatarType | null
  email: string
  first_name: string | null
  last_name: string | null
  role: ROLE
  phone: string | null
}

// eslint-disable-next-line
export interface UserModel extends BaseUserType {}
